import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ListAssigned, ProjectDetailsDto, ListWeek, ListProgress, ListStages, ListRisksMatrix, ListMilestones, ViewRisk, ListDependence } from '../../../interfaces/project/list/projectDetailsDto';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormatterPeso, FormatterPesonNotDecimal, TableOneSearch } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';
import jwt_decode from 'jwt-decode';

export class listPay {

  id: number;
  title: string;
  pay_amount: string;
  listProjectPlayIntoInfo:any
  moneyTypeId: number
  pay_init: string;
}


export class listPaylist {

  hes: string;
  facture: string;
  facture_date: string;


}

interface Permiso {
  exp: number;
  iat: number;
  id: number;
  id_user_erp: number;
  permisses: [];
  role_id: string;
  username: string;
}

export class infolistPay {

  id: number;
  title: string;
  idMoney: number;
  money: string;
  scheduled_date: string;
  rescheduled_date: string;
  real_date: string;
  status: string;
  anexo: string;
  name: string;
  pay_amount: string;
  pay_init: string;
  amount_percent: string;

}
@Component({
  selector: 'app-pay-edit-project',
  templateUrl: './pay-edit-project.component.html',
  styleUrls: ['./pay-edit-project.component.scss']
})
export class PayEditProjectComponent implements OnInit {


  title = "Datos"
  idProject: number;
  id: number;
  rescheduled_dateDate: string;
  scheduled_dateDate: string;
  real_dateDate: string;
  nameProject: string;
  paymentsform: FormGroup;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  createPaylist: listPaylist;
  listAnexo: any[] = [];
  datos: infolistPay;
  listMoney: any[] = [];
  listPayInto: any[] = [];
  private apiService: ApiServiceProject;
  createPayForm: FormGroup;
  editPayForm: FormGroup;
  idSubscription: Subscription;
  items!: FormArray;
  pay_hes: string;
  active: boolean = false
  activeInit: boolean = false
  listmonedas = []

  permise = false;
  public token = "";
  public listPermis: Permiso;
  public permisos_menu: number[] = []

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService

  ) {

    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.idProject = params['id_project'];
      this.title = params['name'];
    });
  }

  ngOnInit(): void {

    this.active = false
    this.activeInit = false
    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

    this.createPayForm = this.fb.group({
      id: [0],
      title: [''],
      scheduled_date: [''],
      real_date: [''],
      rescheduled_date: [''],
      tipo_moneda:[''],
      pay_amount: [''],
      pay_init: [''],
    });

    this.editPayForm = this.fb.group({
      id: [0],
      title: [''],
      tipo_moneda:[''],
      pay_amount: [''],
    });

    this.apiService = new ApiServiceProject(this.http);

    let rs = JSON.parse(localStorage.getItem("info-mtn"));
  
    this.listmonedas = rs.listPlayOption;


    this.token = localStorage.getItem('token')
    this.listPermis = jwt_decode( this.token);

    this.listPermis.permisses.map((dato) => {

      if (dato > 0) {

        if ( this.permisos_menu.find(element => element == dato)) {

        } else {
          this.permisos_menu.push(Number(dato))
        }
      }

    });
    
    if (this.permisos_menu.find(element => element == 51)) {
         this.permise = true;
    }else{
      this.permise = true;
    }


    rs.listProjectPlay.map((dato) => {
      if (dato.id == this.id) {
        this.datos = dato;
        this.listPayInto = dato.listPayInto;

        this.listPayInto.map((pay) => {
          this.items = this.paymentsform.get("items") as FormArray
        
         
            if (pay.facture_date != null) {
        
                pay.facture_date =   moment( pay.facture_date, 'DD-MM-YYYY').format("YYYY-MM-DD");
    
            } else {
              pay.facture_date = "";
    
            }

          let info = this.fb.group({
            id: pay.id,
            hes: pay.hes,
            facture: pay.facture,
            facture_date: pay.facture_date
          });

          if(pay.hes != null){
            this.pay_hes = pay.hes
          }
          this.pay_hes = "";
          this.items.push(info)
        });


      }
    })
      if (this.datos.scheduled_date != null) {

          this.scheduled_dateDate =   moment(this.datos.scheduled_date, 'DD-MM-YYYY').format("YYYY-MM-DD");

      } else {
        this.scheduled_dateDate = "";

      }

    if (this.datos.rescheduled_date != null) {

        this.rescheduled_dateDate =   moment(this.datos.rescheduled_date, 'DD-MM-YYYY').format("YYYY-MM-DD");

    } else {
      this.rescheduled_dateDate = "";

    }
    
    if (this.datos.real_date != null) {

        this.real_dateDate =   moment(this.datos.real_date, 'DD-MM-YYYY').format("YYYY-MM-DD");

    } else {
      this.real_dateDate = "";

    }

    this.createPayForm.patchValue({
      id: this.datos.id,
      title: this.datos.title,
      scheduled_date: this.scheduled_dateDate,
      real_date: this.real_dateDate,
      rescheduled_date: this.rescheduled_dateDate,
      tipo_moneda: this.datos.idMoney,
      pay_amount: this.datos.pay_amount,
      pay_init: this.datos.pay_init
    });

  }
  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  eliminarCampo(index) {
    this.items.removeAt(index)
  }


  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }

  fechaCambio(fecha: string) {

    return  moment(fecha, 'DD-MM-YYYY').format("YYYY-MM-DD");
  }


  actionSelectType(){

    this.createPayForm.get("pay_amount").setValue("");
    this.createPayForm.get("pay_init").setValue("");

  }

  formSubmit(): void {
     this.spinner.show();

    if (this.createPayForm.value.title === '') {
      this.spinner.hide();
      Swal.fire({title: 'Debe seleccionar un título' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.pay_amount === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar un monto' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.pay_init === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar un monto inicial' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if(this.createPayForm.value.tipo_moneda === ''){
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar el tipo de moneda' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

      this.createPay = new listPay();
      this.createPay.id = Number(this.id);
      this.createPay.title = this.createPayForm.value.title;
      this.createPay.pay_amount = this.createPayForm.value.pay_amount;
      this.createPay.moneyTypeId = Number(this.createPayForm.value.tipo_moneda)
      this.createPay.pay_init = this.createPayForm.value.pay_init;

    this.createPay.listProjectPlayIntoInfo = []
    if(this.items != null){
      for(let info of this.items.value){

        let payInfo = {
          id:info['id'],
          hes: info['hes'],
          facture:info['facture'],
          facture_date: moment(info['facture_date']).format("DD-MM-YYYY")
        }

        this.createPay.listProjectPlayIntoInfo.push(payInfo)
      }
    }


      this.apiService.putUpdate('project-play-update', this.createPay)
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            Swal.fire({title:'Exito!',text:data.message,icon: 'success',heightAuto: false})
              .then(() => [
              ]);
            this.router.navigate(['/pdg/project/pay/list', this.idProject, this.title]);
          },
          error: (error) => {
            this.errorService.error(error);
          }
        });
  }

  transformAmount(event: any, type){
    
    let data =  event.target.value;

    var onlyNumbers =  data.toString().replace(/[^0-9,.]+/g, "");

    if( this.createPayForm.value.tipo_moneda == 1 || this.createPayForm.value.tipo_moneda == 16){
    
      let info = data.toString().replace(/[^0-9,.]+/g, "");
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('')
      onlyNumbers = info
      
      onlyNumbers = FormatterPesonNotDecimal().format(onlyNumbers)
    }else{
      
      let info = data.toString().replace(/[^0-9,.]+/g, "");
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('.')
      onlyNumbers = info
      
      onlyNumbers = FormatterPeso().format(onlyNumbers)
    }

    if(type == 1){
      this.active = false;
      if(this.createPayForm.value.pay_amount != onlyNumbers){
        this.createPayForm.get("pay_amount").setValue(onlyNumbers);
      }
    }else if(type == 2){
      this.activeInit = false;
      if(this.createPayForm.value.pay_init != onlyNumbers){
        this.createPayForm.get("pay_init").setValue(onlyNumbers);
      }
    }
  }

  onKey(){
    this.active = true;
  }

  onKeyInit(){
    this.activeInit = true;
  }

  valideNegative(monto){
    if(monto.toString().includes("-")){
      return true
    }
    return false
  }
}